import { store, getContext } from '@wordpress/interactivity';

const { state } = store( 'music-site', {
	state: {},
	actions: {
		toggleSearchDialog() {
            // Toggle the global state
            state.isSearchOpen = ! state.isSearchOpen;
            
            // If opening, show the dialog
            if ( state.isSearchOpen ) {
                const dialog = document.getElementById( state.searchDialog );
                // only attach the close listener once so we don't accumulate
                if ( ! dialog.dataset.closeListenerAttached ) {
                    dialog.addEventListener( 'close', () => {
                        // sync state when the native dialog is dismissed (light dismiss, ESC, etc.)
                        state.isSearchOpen = false;
                    } );
                    dialog.dataset.closeListenerAttached = '1';
                }
                dialog.show();
            }
        },
		closeSearchDialog() {
            // Close by updating state
            state.isSearchOpen = false;
            const dialog = document.getElementById( state.searchDialog );
            dialog.close();
        },
	},
	callbacks: {},
} );
